import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { Toolbar } from "@mui/material";

export interface ISecurityQuestionsScreenToolbar {
	isSubmitting: boolean;
}

export const SecurityQuestionsScreenToolbar: FC<ISecurityQuestionsScreenToolbar> = ({
	isSubmitting = false,
}) => {
	return (
		<Toolbar>
			<>
				<EnhancedButtonPrimeReact
					label="Save"
					loading={isSubmitting}
					type="submit"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
			</>
		</Toolbar>
	);
};
